import React from 'react';
import { Link } from '@inertiajs/react';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        <nav className="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">
          <div className="px-5 py-2">
            <Link href="/about" className="text-base text-muted-foreground hover:text-foreground">
              About
            </Link>
          </div>
          <div className="px-5 py-2">
            <Link href="/contact" className="text-base text-muted-foreground hover:text-foreground">
              Contact
            </Link>
          </div>
          <div className="px-5 py-2">
            <Link href="/privacy" className="text-base text-muted-foreground hover:text-foreground">
              Privacy
            </Link>
          </div>
          <div className="px-5 py-2">
            <Link href="/terms" className="text-base text-muted-foreground hover:text-foreground">
              Terms
            </Link>
          </div>
        </nav>
        <div className="mt-8 flex justify-center space-x-6">
          <p className="text-center text-base text-muted-foreground">
            &copy; {new Date().getFullYear()} REZY. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
